module.exports = __webpack_public_path__ + "a25ab6f16930c594c13ff6ae5f20d9dc.pdf";